import React from 'react';
import GoalForm from './GoalForm';
import GoalsList from './GoalsList';

function GoalsSection({ goals, addGoal, updateGoal, deleteGoal }) {
  const handleAddGoal = async (goalText, goalType) => {
    if (goalText.trim() === '') return;
    try {
      await addGoal(goalText, goalType);
    } catch (error) {
      console.error('Error adding goal:', error);
    }
  };

  const handleToggleGoal = async (id) => {
    const goal = goals.find(g => g.id === id);
    if (goal) {
      try {
        await updateGoal(id, { completed: !goal.completed });
      } catch (error) {
        console.error('Error updating goal:', error);
      }
    }
  };

  const handleDeleteGoal = async (id) => {
    try {
      await deleteGoal(id);
    } catch (error) {
      console.error('Error deleting goal:', error);
    }
  };

  return (
    <>
      <GoalForm onAddGoal={handleAddGoal} />
      <GoalsList 
        goals={goals} 
        onToggleGoal={handleToggleGoal} 
        onDeleteGoal={handleDeleteGoal} 
      />
    </>
  );
}

export default GoalsSection;